export const TimeBasedDocStatuses = [
  'NO EXPIRY SET',
  'VALID',
  "VALID (CAN'T EXPIRE)",
  'EXPIRES IN 45 DAYS',
  'EXPIRED',
  'NO DOC',
  'DOCS OUTSTANDING',
]
